.btnClose {
  background-size: 50% !important;
}
